import { Observable, } from 'rxjs';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/concat';
import 'rxjs/add/operator/do';

import INSPECTIONS_ACTIONS from '../../constants/actions/inspections';
import InspectionApi from '../../api/inspection';
import InspectionsAction from '../actions/inspections';
import inspections from '../../components/app/dashboard/inspections/inspections'
import { INSPECTION_STATE } from '../../constants/app/inspection';

class InspectionsEpic{
	static changePageNext = (action$, store, deps) => action$
        .ofType(INSPECTIONS_ACTIONS.CHANGE_PAGE_NEXT)
        .switchMap(({ payload }) => {
            const page = store.getState().InspectionsReducer.page + 1;
            const size = store.getState().InspectionsReducer.size;
			const states = store.getState().InspectionsReducer.states;
			const searchFilter = store.getState().InspectionsReducer.searchFilter;
			const searchValue = store.getState().InspectionsReducer.searchValue;
            const request = Observable.of(InspectionsAction.load(page, size, states, searchFilter, searchValue));
            return request;
        });
    static changePageBack = (action$, store, deps) => action$
        .ofType(INSPECTIONS_ACTIONS.CHANGE_PAGE_BACK)
        .switchMap(({ payload }) => {
            const page = store.getState().InspectionsReducer.page - 1;
            const size = store.getState().InspectionsReducer.size;
            const states = store.getState().InspectionsReducer.states;
			const searchFilter = store.getState().InspectionsReducer.searchFilter;
			const searchValue = store.getState().InspectionsReducer.searchValue;
            const request = Observable.of(InspectionsAction.load(page, size, states, searchFilter, searchValue));
            return request;
        });
	static changeState = (action$, store, deps) => action$
		.ofType(INSPECTIONS_ACTIONS.CHANGE_STATE)
		.switchMap(({ payload }) => {
			const size = store.getState().InspectionsReducer.size;
			if(payload  === ''){
				payload = Object.keys(INSPECTION_STATE).join(',')
			}
			const states = payload.states;
			const searchFilter = payload.searchFilter ? payload.searchFilter : 'NONE';
			const searchValue = payload.searchValue;
			const obsLoad = Observable.of(InspectionsAction.load(0, size, states, searchFilter, searchValue));
			return obsLoad;
		});
	static load = (action$, store, deps) => action$
		.ofType(INSPECTIONS_ACTIONS.LOAD)
		.switchMap(({ payload }) => {
			const api = new InspectionApi(action$, store, deps);
			const request = api.getAll(payload)
				.do(r => r.response.forEach(ins => store.dispatch(InspectionsAction.loadDetail(ins))))
				.mergeMap((response) => {
					const inspections = response.response;
					const total = parseInt(response.xhr.getResponseHeader('x-total-count'), 10);

					inspections.forEach(element => {
						Observable.of(InspectionsAction.loadDetail(element));
					});

					return Observable.of(InspectionsAction.loadOk(inspections, total));

				})
				.catch(error => Observable.of(InspectionsAction.loadError({
					message: error.message,
					status: error.status
				})));
			return Observable.concat(
				request
			);
		});
	static loadDetail = (action$, store, deps) => action$
		.ofType(INSPECTIONS_ACTIONS.LOAD_DETAIL)
		.flatMap(({ payload }) => {
			const api = new InspectionApi(action$, store, deps);
			const requestState = api.getState({userIdentity: payload.userIdentity, requestId: payload.id})
				.map(response => InspectionsAction.loadStateOk(payload, response))
				.catch(error => Observable.of(InspectionsAction.loadStateError({
					message: error.message,
					status: error.status
				})));
			const requestCustomer = api.getCustomer({userIdentity: payload.userIdentity})
				.map(response => InspectionsAction.loadCustomerOk(payload, response))
				.catch(error => Observable.of(InspectionsAction.loadCustomerError({
					message: error.message,
					status: error.status
				})));
			return Observable.concat(
				requestState,
				requestCustomer
			)
		});
}

export default function InspectionsEpics (action$, store, deps){
	return Observable.merge(
		InspectionsEpic.changeState(action$, store, deps),
		InspectionsEpic.load(action$, store, deps),
		InspectionsEpic.loadDetail(action$, store, deps),
		InspectionsEpic.changePageBack(action$, store, deps),
		InspectionsEpic.changePageNext(action$, store, deps),
	);
} 


// WEBPACK FOOTER //
// ./src/redux/epics/inspections.js